module.exports = __webpack_public_path__ + "static/media/search-sample-5.547fa21d.png";